//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import PedidoDevolucaoCrudList from './PedidoDevolucaoCrudList';
import PedidoDevolucaoEdit from './PedidoDevolucaoEdit';
export default class PedidoDevolucaoCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/pedidoDevolucao"
            exact
            component={PedidoDevolucaoCrudList}
          />
          <Route
            path="/pedidoDevolucao/novo"
            exact
            component={PedidoDevolucaoEdit}
          />
          <Route path="/pedidoDevolucao/:id" component={PedidoDevolucaoEdit} />
        </Switch>
      </React.Fragment>
    );
  }
}
